import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-no-listing-builder',
  templateUrl: './no-listing-builder-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoListingBuilderDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NoListingBuilderDialogComponent>,
    public dialog: MatDialog,
  ) {}

  public openDialog(): void {
    this.dialog.open(NoListingBuilderDialogComponent);
  }

  close(): void {
    this.dialogRef.close();
  }
}
